import * as React from 'react';

import styled from '@emotion/styled';

import { Header } from 'bundles/enterprise-ui/components';

const Container = styled.div({
  backgroundColor: 'var(--cds-color-neutral-background-primary)',
  minHeight: '100vh',
});

const Content = styled.div({
  textAlign: 'center',
  maxWidth: 550,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
});

export const InviteAcceptanceContainer = ({ children, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <Container {...props}>
    <Header />
    <Content>{children}</Content>
  </Container>
);
